import OrganizationAdminForm from './OrganizationAdminForm';

export default OrganizationAdminForm;
